import { IApplicationState } from '../../types/redux';
import { IDeveloperValuationFilters } from '../../types/developerValuation/developerValuationFilters';

export const selectDeveloperValuationFiltersData = (
  state: IApplicationState,
): IDeveloperValuationFilters | undefined => {
  return state.developerValuation.developerValuation?.filters;
};
